// TODO: Update services auth.
export const getDefaultHeaders = () => {
    return {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + btoa('ms_eligibility@paylock.com:Tuu6qNqG3VTPTCUF'),
        // 'Authorization': 'Basic ' + btoa('testadmin@paylock.com:password01'),
        'Content-Type': 'application/json',
    };
}
